import React from 'react';
import { Badge } from '@shared/ui/badge';
import { useTranslation } from 'react-i18next';

interface DetailsHeaderProps {
  icon: React.ReactNode;
  iconBgColor: string;
  iconTextColor: string;
  title: string;
  status: string;
  priority?: string;
  id: string;
  submittedDate: string;
}

export const DetailsHeader = ({
  icon, iconBgColor, iconTextColor, title, status, priority, id, submittedDate
}: DetailsHeaderProps) => {
  const { t } = useTranslation();
  // Simple badge coloring mapping
  const getStatusClasses = (s: string) => {
    if (s === 'Completed') return 'bg-gray-100 text-gray-700 border-gray-200';
    if (s === 'In Progress' || s === 'Under Review') return 'bg-orange-50 text-orange-600 border-orange-200';
    if (s === 'Assigned') return 'bg-purple-50 text-purple-600 border-purple-200';
    return 'bg-blue-50 text-blue-600 border-blue-200';
  };

  const getPriorityClasses = (p?: string) => {
    if (p === 'High') return 'bg-red-50 text-red-600 border-red-200';
    if (p === 'Medium') return 'bg-yellow-50 text-yellow-600 border-yellow-200';
    return 'bg-green-50 text-green-600 border-green-200';
  };

  return (
    <div className="p-6 pb-4 border-b border-gray-100 pr-12">
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-3">
          <div className={`p-2 rounded-lg ${iconBgColor} ${iconTextColor}`}>
            {icon}
          </div>
          <h2 className="text-xl font-bold text-gray-900">{title}</h2>
        </div>
      </div>
      <div className="mt-2 text-sm text-gray-500 font-medium">
        <span className="text-gray-700 font-semibold">{id}</span>
        <span className="mx-2">·</span>
        <span>{t("Submitted")} {submittedDate}</span>
      </div>
    </div>
  );
};
